import { render, staticRenderFns } from "./CreditNotesList.vue?vue&type=template&id=2fef4297&"
import script from "./CreditNotesList.vue?vue&type=script&lang=js&"
export * from "./CreditNotesList.vue?vue&type=script&lang=js&"
import style0 from "./CreditNotesList.vue?vue&type=style&index=0&id=2fef4297&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports